import i18n from "@/plugins/i18n";

export function getJournalManagementColumns(handlers) {
  return getColumns(handlers, journalManagementColumns);
}

export function getConsentDocumentManagementColumns(handlers) {
  return getColumns(handlers, consentDocumentManagementColumns);
}

export function getJournalPublishManagementColumns(handlers) {
  return getColumns(handlers, journalPublishManagementColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const journalManagementColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  // {
  //   text: i18n.t("label.title_eng"),
  //   value: "title_eng",
  //   type: "text",
  // },
  {
    text: i18n.t("label.submission_start_date"),
    value: "submission_start_date",
    type: "text",
  },
  {
    text: i18n.t("label.submission_end_date"),
    value: "submission_end_date",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "search",
        color: "black",
        key: "detail",
        handler: null,
      },
      {
        icon: "info",
        color: "info",
        key: "info",
        handler: null,
      },
      // {
      //   icon: "edit",
      //   color: "primary",
      //   key: "edit",
      //   handler: null,
      // },
    ],
  },
];

const consentDocumentManagementColumns = [
  {
    text: i18n.t("label.document_type_name"),
    value: "document_type_name",
    type: "text",
    highlighted: true,
  },
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "search",
        color: "black",
        key: "detail",
        handler: null,
      },
    ],
  },
];

export const paperPublishManagementColumns = [
  {
    text: i18n.t("label.title"),
    type: "text",
  },
  {
    text: i18n.t("label.title_eng"),
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
  },
];

const journalPublishManagementColumns = [
  {
    text: i18n.t("label.status"),
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.submission_start_date"),
    value: "submission_start_date",
    type: "text",
  },
  {
    text: i18n.t("label.submission_end_date"),
    value: "submission_end_date",
    type: "text",
  },
  // {
  //   text: i18n.t("label.remain_papers"),
  //   value: "can_publish_papers_count",
  //   type: "text",
  // },
  // {
  //   text: i18n.t("label.publish_papers"),
  //   value: "publish_papers_count",
  //   type: "text",
  // },
  {
    text: i18n.t("label.published_at"),
    value: "publish_date",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "open_in_new",
        color: "black",
        key: "show",
        handler: null,
      },
    ],
  },
];
